import type { Time } from "@pdfking/structs"

/**
 * Pauses execution for a specified number of seconds.
 * Returns a promise that resolves after the delay.
 *
 * @param seconds - Number of seconds to sleep
 * @returns A promise that resolves after the specified delay
 *
 * @example
 * ```ts
 * import { Sleep } from "@pdfking/tfunc"
 *
 * console.log('Starting...');
 * await Sleep(1); // Wait 1 second
 * console.log('Done!');
 *
 * // Use in async generators
 * async function* delayedNumbers() {
 *   yield 1;
 *   await Sleep(0.1);
 *   yield 2;
 *   await Sleep(0.1);
 *   yield 3;
 * }
 * ```
 */
export const Sleep = (seconds: Time): Promise<void> =>
  new Promise(resolve => setTimeout(resolve, seconds * 1000))
